import React, { useEffect, useState } from 'react'
import './App.css'
import './EditBankDetails.css'
import { useLocation, useHistory } from 'react-router-dom'
import Axios from 'axios'
import { IoIosArrowBack } from 'react-icons/io'
import { IoCardOutline, IoWarningOutline } from 'react-icons/io5'
import { banks } from './BankList'
import { payfastBanks } from './BankList'
import { bankBranchCodes } from './BankList'
import { predefinedBanks } from './BankList'
import ReEnterPasswordModal from './modals/verify-identity/ReEnterPasswordModal'
import { BiMenu } from 'react-icons/bi'
import { CheckUserLogin } from './sessions/CheckUserLoggin'
import SideNavCust from './layouts/SideNavCust'
import Header from './layouts/Header'
import SideNav from './layouts/SideNav'
import SideNavAff from './layouts/SideNavAff'
import { API_URL } from './config'

const EditBankDetails = () => {
  CheckUserLogin()
  const location = useLocation()
  const { responseCode, bankList } = location.state || {}
  const history = useHistory()
  const [bankName, setBankName] = React.useState('')
  const [ozowBankName, setOzowBankName] = useState('')
  const [ozowBankId, setOzowBankId] = useState(0)
  const [customBankName, setCustomBankName] = React.useState('')
  const [branchCode, setBranchCode] = React.useState('')
  const [customBranchCode, setCustomBranchCode] = React.useState('')
  const [accountNumber, setAccountNumber] = React.useState('')
  const [accountName, setAccountName] = React.useState('')
  const [accountType, setAccountType] = React.useState('')
  const [accountHolder, setAccountHolder] = React.useState('')
  const [createdAt, setCreatedAt] = React.useState('')
  const [message, setMessage] = React.useState('')
  const [error, setError] = React.useState(false)
  const [showModal, setShowModal] = useState(false)
  const [errorDisplay, setErrorDisplay] = useState('d-none')
  const [alertState, setAlertState] = useState('success-alert')
  const [isMissing, setIsMissing] = useState(false)
  const [dataMissingMessage, setDataMissingMessage] = useState('')
  const [loggedAccountType, setLoggedAccountType] = useState('')
  const [bankLabel, setBankLabel] = useState('')
  const [count, setCount] = useState(0)
  const [isFound, setIsFound] = useState(true)
  const [loading, setLoading] = useState(false)
  const isMobile = window.innerWidth <= 768
  const [isMob, setIsMob] = useState()
  const [collapsed, setCollapsed] = useState(isMobile)
  const [ozowBankList, setOzowBankList] = useState([])

  const updateIsMobile = () => {
    const mobile = window.innerWidth <= 768
    setIsMob(mobile)
    setCollapsed((prev) => (mobile ? true : prev))
  }

  const ozowBanks = () => {
    // Axios.get(`${API_URL}/apps/kscanner/ozow.php`, { withCredentials: true })
    Axios.get(`${API_URL}/apps/kscanner/webservices.php?query=OZOWBANKLIST`, {
      withCredentials: true,
    })
      .then((response) => {
        const data = response.data // Axios gives you parsed JSON here

        setOzowBankList(data)

        // console.log(data)
      })
      .catch((error) => {
        console.error('Error fetching banks:', error)
        setLoading(false)
      })
  }

  useEffect(() => {
    const businessname = localStorage.getItem('businessname')
    const businessid = localStorage.getItem('businessid')
    document.title = 'Edit bank details'

    ozowBanks()
    Axios.get(
      `${API_URL}/apps/kscanner/webservices.php?query=RETRIEVEBANKDETAILS&business_id=${businessid}`,
      {
        withCredentials: true,
      },
    )
      .then((response) => {
        const data = response.data
        if (data.status === 'failed') {
          setDataMissingMessage(data.message) // Return message if data is missing
          setIsMissing(true) // Set isMissing to true if there's an error or missing data
          console.log('Error: ', data.message)
          return
        }
        const custBankName = data.bank_name_edit.replace('_', ' ')
        setOzowBankId(data.ozowBankId)
        setLoggedAccountType(data.logged_account_type ?? '')
        setBankName(data.bank_name_edit ?? '')
        setOzowBankName(data.bank_name ?? '')
        setBranchCode(data.branch_code ?? '')
        setCustomBranchCode(data.branch_code ?? '')
        setAccountNumber(data.account_number_edit ?? '')
        setAccountHolder(data.account_holder ?? '')
        setAccountName(data.account_name ?? '')
        setAccountType(data.account_type_edit ?? '')
        setBankLabel(data.bank_label ?? '')
        setCustomBankName(
          isCustomBank
            ? custBankName
                .split(' ')
                .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                .join(' ')
            : ('' ?? ''),
        )
        setCreatedAt(data.created_at)
      })
      .catch(function (error) {
        console.log('Error: ', error)
      })

    updateIsMobile()
    window.addEventListener('resize', updateIsMobile)

    return () => {
      // this runs on unmount
      window.removeEventListener('resize', updateIsMobile)
    }
  }, [count])

  const isCustomBank = !predefinedBanks.includes(bankName)

  const confirmPassword = (password) => {
    if (!password) {
      setError(true)
      setMessage('Please enter your password to verify your identity.')
      setAlertState('error-alert')
      setErrorDisplay('d-block')
      setTimeout(() => {
        setErrorDisplay('d-none')
        setMessage('')
      }, 5000)
      return
    }

    const isInvalidBranch = Boolean(branchCode || customBranchCode)
    const isInvalidBank = Boolean(bankName || customBankName)
    // if (
    //   accountHolder.trim() === "" ||
    //   accountNumber.trim() === "" ||
    //   accountType.trim() === "" ||
    //   branchCode.trim() === "" ||
    //   bankName.trim() === ""
    // ) {
    //   setError(true);
    //   setMessage("All fields are required");
    //   setAlertState("error-alert");
    //   setErrorDisplay("d-block");
    //   setShowModal(false);

    //   setTimeout(() => {
    //     setErrorDisplay("d-none");
    //     setMessage("");
    //   }, 5000);
    //   return;
    // }
    // Verify the password before updating details
    setLoading(true)
    const data = new FormData()
    data.append('password', password)
    data.append('query', 'VERIFYIDENTITY')

    Axios.post(`${API_URL}/apps/kscanner/webservices.php`, data, {
      withCredentials: true,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
      .then((response) => {
        if (response.data.status === 'failed') {
          setLoading(false)
          setError(true)
          setMessage(response.data.message)
          setAlertState('error-alert')
          setErrorDisplay('d-block')
          setTimeout(() => {
            setErrorDisplay('d-none')
            setMessage('')
          }, 7000)
          return
        }

        // If password verification is successful, proceed to update details
        setError(false)
        updateDetails(accountHolder, accountName, accountNumber, accountType, branchCode, bankName)
        // setShowModal(false);
      })
      .catch((error) => {
        setLoading(false)
        console.error('Error verifying password:', error)
        setError(true)
        setMessage('An error occurred while verifying your password: ' + error)
        setAlertState('error-alert')
        setErrorDisplay('d-block')
        setTimeout(() => {
          setErrorDisplay('d-none')
          setMessage('')
        }, 5000)
        return
      })
  }

  // const handleBankUpdate = () => {
  //   setShowModal(true);
  // };

  const handleBankChange = (e) => {
    if (accounttype === 'customer') {
      const bank = e.target.value
      setBankName(bank)

      setBranchCode(bankBranchCodes[bank.split('_')[0]] || '')

      if (!bankBranchCodes[bank.split('_')[0]]) {
        setIsFound(false)
      } else {
        setIsFound(true)
      }
    } else {
      const bankId = e.target.value
      setOzowBankId(e.target.value)
      setBankName('null')

      Axios.get(
        `${API_URL}/apps/kscanner/webservices.php?query=GET-OZOW-BANK-UNIVERSAL-BRANCH-CODE&bankId=${bankId}`,
        {
          withCredentials: true,
        },
      )
        .then((response) => {
          const data = response.data
          setBranchCode(data.branchCode)
          console.log(data.branchCode)
        })
        .catch((error) => {
          console.error('Error fetching banks:', error)
        })
    }
  }

  const updateDetails = (
    accountHolder,
    accountName,
    accountNumber,
    accountType,
    branchCode,
    bankName,
  ) => {
    const businessid = localStorage.getItem('businessid')
    const baseURL = `${API_URL}/apps/kscanner/webservices.php`
    const dataForm = new FormData()
    dataForm.append('account_holder', accountHolder)
    dataForm.append('account_name', accountName)
    dataForm.append('account_number', accountNumber)
    dataForm.append('bank_account_type', accountType)
    dataForm.append('branch_code', branchCode)
    dataForm.append('bank_name', bankName)
    dataForm.append('custom_bank_name', customBankName)
    dataForm.append('ozowBankId', ozowBankId)
    dataForm.append('query', 'SAVEBANKDETAILS')

    Axios({
      method: 'post',
      url: baseURL,
      data: dataForm,
      withCredentials: true,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
      .then((response) => {
        setCount(count + 1)
        const data = response.data
        if (data.status === 'failed') {
          setMessage(data.message)
          setError(true)
          console.log('Error: ', data.message)
          setAlertState('error-alert')
          setErrorDisplay('d-block')
          // setShowModal(true);

          return
        }
        setMessage(data.message)
        setError(false)
        console.log('Success: ', data.message)
        setAlertState('success-alert')
        setErrorDisplay('d-block')
        setShowModal(false)
      })
      .catch((error) => {
        console.log('Error: ', error)
        setMessage('An error occurred while updating details.')
        setAlertState('error-alert')
        setError(true)
      })

    setTimeout(() => {
      setErrorDisplay('d-none')
      setMessage('')
    }, 5000)
  }

  let bankNameList = banks

  if (responseCode === 'BANK_DETAILS_MISSING') {
    bankNameList = bankList
  }

  const selectedBank = `${bankName}_${bankLabel}`

  const addUpdate = () => {
    if (
      accountHolder.trim() === '' ||
      accountNumber.trim() === '' ||
      accountType.trim() === '' ||
      branchCode.trim() === '' ||
      bankName.trim() === ''
    ) {
      setError(true)
      setMessage('All fields are required')
      setAlertState('error-alert')
      setErrorDisplay('d-block')
      setShowModal(false)

      setTimeout(() => {
        setErrorDisplay('d-none')
        setMessage('')
      }, 5000)
      return
    } else {
      setShowModal(true)
    }
  }

  const handleToggle = () => {
    setCollapsed((prev) => !prev)
  }

  const accounttype = localStorage.getItem('accounttype')

  return (
    <div className="view">
      <Header />
      {accounttype === 'customer' ? (
        <>
          <SideNavCust collapsed={collapsed} onToggle={handleToggle} />
        </>
      ) : accounttype === 'business' ? (
        <>
          <SideNav collapsed={collapsed} onToggle={handleToggle} />
        </>
      ) : (
        <SideNavAff collapsed={collapsed} onToggle={handleToggle} />
      )}

      {/* ✅ Mobile overlay when sidebar is open */}
      {isMobile && !collapsed && <div className="mobile-overlay active" onClick={handleToggle} />}

      {isMob && collapsed && (
        <label className="mobile-toggle" onClick={handleToggle}>
          <BiMenu size={25} />
        </label>
      )}

      <main
        className="eb-page"
        style={{
          marginTop: 'var(--header-h)',
          marginLeft: isMob ? 0 : collapsed ? '76px' : '252px',
        }}
      >
        <div className="eb-container">
          <button type="button" className="eb-back" onClick={() => history.goBack()}>
            <IoIosArrowBack size={18} />
            <span>Back</span>
          </button>

          <section className="eb-card">
            <div className="eb-card__head">
              <div className="eb-card__icon">
                <IoCardOutline size={22} />
              </div>
              <h1>Bank details</h1>
            </div>

            <div className="eb-notice-wrap">
              {isMissing ? (
                <div className="eb-notice">
                  <IoWarningOutline size={20} />
                  <div className="eb-notice__body">
                    <strong>Important:</strong>
                    <span>
                      Please ensure you enter correct banking details to avoid any issues with
                      payouts.
                    </span>
                  </div>
                </div>
              ) : (
                <div className="eb-notice">
                  <IoWarningOutline size={20} />
                  <div className="eb-notice__body">
                    <strong>Important:</strong>
                    <span>
                      Please ensure that your banking details are correct to avoid any issues with
                      payouts.
                    </span>
                  </div>
                </div>
              )}
            </div>

            <div className="eb-form">
              <div className="eb-field eb-field--wide">
                <label>Select your bank</label>
                {accounttype === 'customer' ? (
                  <select className="eb-input" value={bankName} onChange={handleBankChange}>
                    {payfastBanks.map((bank) => (
                      <option key={bank.bank_name} value={`${bank.bank_name}_${bank.label}`}>
                        {bank.label}
                      </option>
                    ))}
                  </select>
                ) : (
                  <select
                    className="eb-input"
                    value={ozowBankId} // controlled by rowId
                    onChange={handleBankChange}
                  >
                    <option value="">--Select--</option>
                    {ozowBankList.map(({ rowId, bankGroupName }) => (
                      <option key={rowId} value={rowId}>
                        {bankGroupName}
                      </option>
                    ))}
                  </select>
                )}
              </div>

              <div className="eb-field">
                <label>Branch code</label>
                <input
                  type="number"
                  placeholder="Type branch code here"
                  className="eb-input"
                  value={branchCode}
                  onChange={(e) => setBranchCode(e.target.value)}
                  readOnly={isFound ? true : false}
                />
              </div>

              <div className="eb-field">
                <label>Type of account</label>
                <select
                  className="eb-input"
                  value={accountType}
                  onChange={(e) => setAccountType(e.target.value)}
                >
                  <option value="">--Select--</option>
                  <option value={accounttype === 'customer' ? 'savings' : 'cheque'}>
                    Cheque/Current
                  </option>
                  <option value="savings">Savings</option>
                </select>
              </div>

              <div className="eb-field">
                <label>Account holder</label>
                <input
                  type="text"
                  className="eb-input"
                  value={accountHolder}
                  onChange={(e) => setAccountHolder(e.target.value)}
                />
              </div>

              <div className="eb-field">
                <label>Account number</label>
                <input
                  type="text"
                  className="eb-input"
                  value={accountNumber}
                  onChange={(e) => setAccountNumber(e.target.value)}
                />
              </div>

              <div className="eb-meta eb-field--wide">
                <span>Details updated on</span>
                <strong>{createdAt ? createdAt : 'N/A'}</strong>
              </div>
            </div>

            <div className="eb-foot">
              <button type="button" className="eb-btn" onClick={() => addUpdate()}>
                Add/Update
              </button>
            </div>
          </section>
        </div>
      </main>

      <ReEnterPasswordModal
        isOpen={showModal}
        onConfirm={confirmPassword}
        onCancel={() => setShowModal(false)}
        loading={loading}
      />
      <div className={alertState + ' text-center ' + errorDisplay}>{message}</div>
    </div>
  )
}

export default EditBankDetails
